// #region Imports
import { 
	useState, 
	useEffect 
} from "react"
// #endregion

function Avaibility() {
	const [time, setTime] = useState(
		new Date().toLocaleTimeString(
			"en-IN", 
			{
				hour: "2-digit",
				minute: "2-digit",
				timeZone: "Asia/Kolkata",
			}
		),
	)

	useEffect(() => {
		setInterval(
			() => setTime(
				new Date().toLocaleTimeString(
					"en-IN", 
					{
						hour: "2-digit",
						minute: "2-digit",
						timeZone: "Asia/Kolkata",
					}
				),
			),
			60000,
		)
	}, [])

	return (
		<section 
			className="flex flex-col gap-1 items-end text-[0.9em] font-[500] z-50 font-mada text-charcoal"
		>

			<p 
				className="select-none"
			>
				Delhi
				<b> 🕒 {time.toUpperCase()} </b>
				GMT (+5:30)
			</p>

            <p 
				className="select-none capitalize"
			>
				🟢 Available for New Projects
			</p>

            <a 
				href={"mailto:vshon447@gmail.com"} 
				title="Email Me"
				className="no-underline"
			>
				📧 <u> vshon447@gmail.com </u>
			</a>
			
		</section>
	)
}

export default Avaibility
